import script from "./SignInForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInForm.vue?vue&type=script&setup=true&lang=ts"

import "./SignInForm.vue?vue&type=style&index=0&id=32a1ebde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a1ebde"]])

export default __exports__